import { Button } from '@advanza/ui'
import NiceModal, { useModal } from '@ebay/nice-modal-react'
import BaseModal, {
    BaseModalFooter,
    BaseModalHeader,
    BaseModalMainContent,
} from '@trustoo/components/modal/BaseModal'

interface CentralizedReviewCollectionModalProps {
    enable: boolean
    nrFranchiseAccounts: number
}

const CentralizedReviewCollectionModal = NiceModal.create(
    ({ enable, nrFranchiseAccounts }: CentralizedReviewCollectionModalProps) => {
        const modal = useModal()
        const accounts = `${nrFranchiseAccounts} ${nrFranchiseAccounts === 1 ? 'account' : 'accounts'}`

        const close = (confirmed: boolean) => {
            modal.resolve(confirmed)
            modal.hide()
        }

        return (
            <BaseModal onClose={() => close(false)}>
                <BaseModalHeader>
                    <h2 className="text-display-xs font-bold">
                        {enable ? 'Share reviews across the franchise' : 'Stop sharing reviews'}
                    </h2>
                </BaseModalHeader>
                <BaseModalMainContent>
                    {enable ? (
                        <div className="grid gap-3">
                            <p>
                                Every review collected by any account of this franchise will count
                                for all <b>{accounts}</b>: the same review list, the same number of
                                reviews and the same review score.
                            </p>
                            <p>
                                This applies to the whole franchise, not only this account, and it
                                covers reviews from every source. Because the review score feeds the
                                Trustoo score, it changes where all of these accounts rank in search
                                results.
                            </p>
                        </div>
                    ) : (
                        <div className="grid gap-3">
                            <p>
                                All <b>{accounts}</b> of this franchise go back to showing only the
                                reviews they collected themselves.
                            </p>
                            <p>
                                Accounts that were relying on the shared reviews will lose review
                                count and review score, which lowers their position in search
                                results.
                            </p>
                        </div>
                    )}
                </BaseModalMainContent>
                <BaseModalFooter>
                    <div className="row justify-end gap-2">
                        <Button appearance="outlined_primary" onClick={() => close(false)}>
                            Cancel
                        </Button>
                        <Button appearance="primary" onClick={() => close(true)}>
                            {enable ? 'Share reviews' : 'Stop sharing'}
                        </Button>
                    </div>
                </BaseModalFooter>
            </BaseModal>
        )
    },
)

export default CentralizedReviewCollectionModal
